import axiosInstance from "../backend/axiosInstance";

export const AgentIcons = {};

let fetched = false;

export async function fetchAgentIcons() {
  if (fetched) return;
  fetched = true;

  try {
    const response = await axiosInstance.get("/agent-icons/");

    response.data.forEach((item) => {
      AgentIcons[item.agentsName] = item.link;
    });
  } catch (error) {
    console.error("Error fetching agent icons:", error);
  }
}